<template>
  <div class="proposta__acompanhamento" :class="{ scrollContent: timeline }">
    <!-- <h1 class="proposta__title">
			Histórico Análise
    </h1>-->
    <v-list two-line subheader class="elevation-1">
      <v-list-tile
        :class="{ timeline_version: timeline }"
        avatar
        v-for="(followup, index) in ordernedFollowups"
        :key="index"
      >
        <v-list-tile-content :class="{ timeline_version: timeline }">
          <v-list-tile-sub-title>{{ followup.nome }}</v-list-tile-sub-title>
          {{ followup.descricao }}
          <!-- <v-list-tile-title
          v-html="followup.descricao" />-->
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-action-text>{{
            followup.data_hora | moment("DD MMM YYYY[, às ]hh:mm")
          }}</v-list-tile-action-text>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-if="!followups.length">
        <v-list-tile-content :class="{ timeline_version: timeline }">
          <v-list-tile-title class="text-xs-center"
            >Nenhum registro encontrado</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<style lang='scss' scoped>
.proposta__title {
  color: #282498;
  font-size: 18px;
}
.proposta__acompanhamento /deep/ .v-list__tile {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 72px;
  padding-bottom: 12px;
  padding-top: 12px;
  height: auto;
}
.proposta__acompanhamento /deep/ .v-list__tile__action {
  min-width: 140px;
}
.proposta__acompanhamento
  /deep/
  div[role="listitem"]:last-of-type
  /deep/
  .v-list__tile {
  border-bottom: 0;
}
.proposta__acompanhamento .v-list /deep/ .v-list__tile__action span {
  align-self: flex-start;
  margin-top: 10px;
}

.timeline_version {
  font-size: 12px;
}

.scrollContent {
  max-height: 450px;
  min-height: 100px;
  overflow-y: auto;
  padding-bottom: 73px;
}
</style>

<script lang="js">
import moment from "moment";
export default {
  name: "PropostaExpandidaAcompanhamento",

  

  computed: {
    ordernedFollowups() {
      this.followups.sort(function (a, b) {
        return new Date(b.data_hora) - new Date(a.data_hora);
      });
      return this.followups;
    },
  },

  mounted() {},
  props: ["followups", "timeline"],
};
</script>





// WEBPACK FOOTER //
// src/components/PropostaExpandidaAcompanhamento.vue